// extracted by mini-css-extract-plugin
export default {"container":"JourneyCard_container__Z+Buu","hero":"JourneyCard_hero__T8N3r","title":"JourneyCard_title__ZVAA7","journeyInfo":"JourneyCard_journeyInfo__+rRuN"};